<div class="text-center font-bold text-2xl mb-1 mt-4 g-c-primaryDarkColor" style="padding-top: 5% !important;">
    {{ 'StrategyAlignment' | navTitle | async }}</div>

<div class="flex justify-content-center  mx-auto w-7">
    <div class="text-center g-c-primaryDarkColor line-height-4">
        {{'alignment_description_1'|translate}}
        <br>
        {{'alignment_description_2'|translate}}
    </div>
</div>

<div class="g-layout__container ">
    <div class=" flex justify-content-center gap-2">
        <div>
            <div class="flex align-items-center">
                <p-dropdown ngClass="drop" (onChange)="strategyOptionsChange()" [(ngModel)]="selectedStrategyId"
                    [options]="strategyOptions" optionLabel="name" optionValue="strategyId"
                    placeholder="{{'select_strategy'|translate}}" />
            </div>
        </div>
        <div>
            <p-button (onClick)="goBack()">
                <div class="flex align-items-center gap-2">

                    <span>
                        {{'back'|translate}}
                    </span>
                    @if(dir=='rtl'){

                    <i class="pi pi-arrow-circle-left"></i>
                    }@else {
                    <i class="pi pi-arrow-circle-right"></i>
                    }
                </div>
            </p-button>

        </div>

    </div>

    @if (strategyOptions.length) {
    <div class="mt-8 w-10 mx-auto  overflow-x-auto">

        <div>
            <div
                class="w-15rem mx-auto flex flex-column gap-3 p-3 border-round-lg surface-100 shadow-2 hover:shadow-4 transition-all cursor-pointer">

                <!-- اسم الاستراتيجية -->
                <div class="text-center font-bold text-900 text-lg">
                    {{alignmentStrategy.name}}
                </div>

                <!-- خط فاصل بسيط -->
                <div class="my-2"
                    style="height: 2px; background: linear-gradient(to right, #3B82F6, #9333EA); border-radius: 50px;">
                </div>

                <!-- العناصر والأرقام -->
                <div class="flex justify-content-between text-700">
                    <div class="flex flex-column align-items-center gap-1">
                        <i class="fa-solid fa-arrows-to-dot text-primary"></i>
                        <span class="font-bold text-800">{{alignmentStrategy.no_pillars}}</span>
                    </div>
                    <div class="flex flex-column align-items-center gap-1">
                        <i class="fa-solid fa-bullseye" style="color: #10B981;"></i>
                        <span class="font-bold text-800">{{alignmentStrategy.no_goals}}</span>
                    </div>
                    <div class="flex flex-column align-items-center gap-1">
                        <i class="fa-solid fa-chart-column" style="color: #3B82F6;"></i>
                        <span class="font-bold text-800">{{alignmentStrategy.no_indicators}}</span>
                    </div>
                    <div class="flex flex-column align-items-center gap-1">
                        <i class="fa-solid fa-rectangle-list" style="color: #9333EA;"></i>
                        <span class="font-bold text-800">{{alignmentStrategy.no_projects}}</span>
                    </div>
                </div>

            </div>


            <div class="arrow-up mx-auto"></div>
            <div class="border-round-xl g-bg-primary" style="height: 12px;">
            </div>
            <div class="flex justify-content-between ">
                @for (pillar of alignmentStrategy?.pillars; track $index) {
                <!-- pillar -->
                <div>
                    <div class="arrow-down mx-auto"></div>


                    <div class="cursor-pointer surface-100 shadow-2 border-round-2xl mb-5 mx-auto w-12rem mt-2 
                    flex flex-column gap-2 py-3 px-4 transition-transform transition-shadow transform hover:scale-110 hover:shadow-5 duration-300"
                        (click)="selectPillar(pillar.id, pillar.goals.length)" [ngStyle]="{
                'background-color': selectedPillarId==pillar.id ? 'var(--primary-color)' : 'var(--secondary-color)',
                'color': selectedPillarId==pillar.id ? 'white' : 'black'
            }">

                        <!-- محتوى الكرت -->
                        <div class="font-bold text-center text-lg">
                            {{pillar.name}}
                        </div>

                        <div class="alignment-br my-2" [ngClass]="{
                    'alignment-white-br': selectedPillarId==pillar.id
                 }"></div>

                        <div class="flex justify-content-between text-sm font-semibold" [ngStyle]="{
                    'color': selectedPillarId==pillar.id ? 'white' : 'var(--DarkBrown)'
                 }">

                            <div class="flex flex-column align-items-center gap-1">
                                <i class="fa-solid fa-bullseye animated-icon"></i>
                                <span class="font-bold">{{pillar.no_goals}}</span>
                            </div>

                            <div class="flex flex-column align-items-center gap-1">
                                <i class="fa-solid fa-chart-column animated-icon"></i>
                                <span class="font-bold">{{pillar.no_indicators}}</span>
                            </div>

                            <div class="flex flex-column align-items-center gap-1">
                                <i class="fa-solid fa-rectangle-list animated-icon"></i>
                                <span class="font-bold">{{pillar.no_projects}}</span>
                            </div>

                        </div>

                    </div>




                    @if(selectedPillarId==pillar.id)
                    {
                    <div id="goals-{{pillar.id}}" class="absolute">

                        @for (goal of pillar.goals; track $index) {
                        <!-- goal -->
                        <div ngClass="{{goal.no_projects ? 'cursor-pointer' : ''}}"
                            class="flex justify-content-center mb-5 transition-all duration-300 hover:scale-105"
                            @fadeInOut>

                            <!-- الخط الرأسي -->
                            <div class="vertical-br"></div>

                            <!-- كرت الهدف -->
                            <div class="flex flex-column justify-content-between my-3">
                                <div class="flex">

                                    @if(dir=='rtl') {
                                    <div class="arrow-left"></div>
                                    } @else {
                                    <div class="arrow-right"></div>
                                    }

                                    <div class="flex w-18rem flex-column gap-4">

                                        <!-- Goal Header -->
                                        <div
                                            class="w-25rem h-4rem flex border-round-2xl shadow-2 surface-100 overflow-hidden transition-all duration-300 hover:shadow-4 hover:scale-105">

                                            <!-- اسم الهدف -->
                                            <div
                                                class="w-6 flex justify-content-center align-items-center bg-primary text-white p-2">
                                                <span pTooltip="{{goal.name}}" tooltipPosition="top"
                                                    class="text-xs font-bold truncate">
                                                    {{goal.name|substring:60}}
                                                </span>
                                            </div>

                                            <!-- إحصائيات الهدف -->
                                            <div
                                                class="w-6 flex justify-content-evenly align-items-center surface-200 text-700">
                                                <div (click)="toggleIndicators(goal.id,goal.no_indicators)" class="flex gap-1 cursor-pointer">
                                                    <i class="fa-solid fa-chart-column"></i>
                                                    <span class="font-bold">{{goal.no_indicators}}</span>
                                                    @if(goal.no_indicators) {
                                                    <i class="fa-solid fa-caret-down text-xs"></i>
                                                    }
                                                </div>
                                                <div (click)="toggoleGoals(goal.id,goal.no_projects)" class="flex gap-1 cursor-pointer">
                                                    <i class="fa-solid fa-rectangle-list"></i>
                                                    <span class="font-bold">{{goal.no_projects}}</span>
                                                    @if(goal.no_projects) {
                                                    <i class="fa-solid fa-caret-down text-xs"></i>
                                                    }
                                                </div>
                                            </div>

                                        </div>

                                        <!-- قائمة المشاريع داخل الهدف -->
                                        @if(goalListId == goal.id) {
                                        <ul class="flex flex-column gap-3 mt-3">

                                            @for (project of goal.projects; track $index) {
                                            <li [@toggleAnimation] (click)="showModal(project)"
                                                class="w-30rem flex h-4rem border-round-2xl shadow-2 surface-100 overflow-hidden hover:shadow-4 hover:scale-105 transition-all duration-300 cursor-pointer">

                                                <!-- اسم المشروع -->
                                                <div
                                                    class="w-5 flex justify-content-center align-items-center bg-primary text-white p-2">
                                                    <span pTooltip="{{project.name}}" tooltipPosition="top"
                                                        class="text-xs font-bold truncate">
                                                        {{project.name|substring:60}}
                                                        @if(project.name.length > 60) { ... }
                                                    </span>
                                                </div>

                                                <!-- إحصائيات المشروع -->
                                                <div
                                                    class="w-7 flex justify-content-evenly align-items-center surface-200 text-700">
                                                    <div class="flex gap-1">
                                                        <i class="fa-solid fa-chart-column"></i>
                                                        <span class="font-bold">{{project.no_indicators}}</span>
                                                    </div>
                                                    <div class="flex gap-1">
                                                        <i class="fa-solid fa-users"></i>
                                                        <span class="font-bold">{{project.no_teammembers}}</span>
                                                    </div>
                                                    <div class="flex gap-1">
                                                        <i class="fa-solid fa-triangle-exclamation"></i>
                                                        <span class="font-bold">{{project.no_risks}}</span>
                                                    </div>
                                                    <div class="flex gap-1">
                                                        <i class="fa-solid fa-list"></i>
                                                        <span class="font-bold">{{project.no_milestones}}</span>
                                                    </div>

                                                    <!-- Progress bar بسيط -->
                                                    <div class="flex justify-content-center items-center bg-green-400 text-white font-bold p-1 rounded-md"
                                                        style="width: 3rem; height: 2rem;"
                                                        [ngStyle]="{'background-color': project.progress_color || '#22C55E'}">
                                                        {{project.progress_percentage}}%
                                                    </div>
                                                </div>

                                            </li>
                                            }

                                        </ul>
                                        }

                                        <!-- قائمة المؤشرات داخل الهدف -->
                                        @if(indicatorListId == goal.id) {
                                        <ul class="flex flex-column gap-3 mt-3">

                                            @for (indicator of goal.indicators; track $index) {
                                            <li [@toggleAnimation]
                                                class="w-30rem flex h-4rem border-round-2xl shadow-2 surface-100 overflow-hidden hover:shadow-4 hover:scale-105 transition-all duration-300">

                                                <!-- اسم المؤشر -->
                                                <div
                                                    class="w-7 flex justify-content-center align-items-center text-white p-2"
                                                    style="background-color: #C91F3B;">
                                                    <span pTooltip="{{indicator.name}}" tooltipPosition="top"
                                                        class="text-xs font-bold truncate">
                                                        {{indicator.name|substring:60}}
                                                        @if(indicator.name.length > 60) { ... }
                                                    </span>
                                                </div>

                                                <!-- معلومات المؤشر -->
                                                <div
                                                    class="w-5 flex justify-content-evenly align-items-center surface-200 text-700">
                                                    <div class="flex flex-column align-items-center gap-1">
                                                        <span class="text-xs font-semibold">{{ 'measurement_cycle' | translate }}</span>
                                                        <span class="font-bold text-xs">{{indicator.measurement_cycle_name}}</span>
                                                    </div>
                                                    <div class="flex flex-column align-items-center gap-1">
                                                        <span class="text-xs font-semibold">{{ 'responsible' | translate }}</span>
                                                        <span class="font-bold text-xs">{{indicator.in_charge_name|substring:15}}</span>
                                                    </div>
                                                </div>

                                            </li>
                                            }

                                        </ul>
                                        }
                                    </div>

                                </div>
                            </div>

                        </div>
                        }
                    </div>


                    }





                </div>
                <!-- pillar end -->
                }
            </div>
        </div>
    </div>
    }@else {
    <div class="mt-8">
        <app-strategy404></app-strategy404>
    </div>
    }
</div>


@if(isModalVisible)
{
<div>

    <div class="g-modal">
        <div class="flex  justify-content-between align-items-center flex-row-reverse ">
            <div (click)="closeModal()"
                class="bg-red-500 g-c-white cursor-pointer  w-3rem p-1 shadow-4 text-center  font-bold text-xl  bg-secondary-color border-round">
                <i class="fa-solid fa-xmark"></i>

            </div>
            <div class="font-bold  g-c-primaryDarkColor">
                {{selectedProject.name}}
            </div>
        </div>
        <div class="br">

        </div>
        <div class="modal__body">

            <div>

                <div class="flex gap-3 justify-content-evenly">

                    <div>


                        <p-button (onClick)="tableType('goalsAndIndicators')"
                            [outlined]="!(tabletype=='goalsAndIndicators')">
                            <div class="flex gap-2">
                                <i class="fa-solid fa-chart-column"></i>
                                <span>
                                    الأهداف والمؤشرات
                                </span>
                            </div>
                        </p-button>

                    </div>
                    <div>
                        <p-button (onClick)="tableType('teamWork')" [outlined]="!(tabletype=='teamWork')">
                            <div class="flex gap-2">

                                <i class="fa-solid fa-users"></i>
                                <span>
                                    فريق العمل
                                </span>
                            </div>

                        </p-button>
                    </div>
                    <div>


                        <p-button (onClick)="tableType('risks')" [outlined]="!(tabletype=='risks')">
                            <div class="flex gap-2">

                                <i class="fa-solid fa-triangle-exclamation"></i>
                                <span>
                                    المخاطر
                                </span>
                            </div>

                        </p-button>
                    </div>
                    <div>


                        <p-button (onClick)="tableType('milestone')" [outlined]="!(tabletype=='milestone')">
                            <div class="flex gap-2">

                                <i class="fa-solid fa-list"></i>
                                <span>
                                    مراحل التنفيذ
                                </span>
                            </div>

                        </p-button>
                    </div>
                </div>


                @if(tabletype=='goalsAndIndicators'){

                <div class="table pt-5">
                    <p-table appendTo="body" [class]="dir" [dir]="dir" [value]="project.goalsIndicators"
                        [paginator]="true" [rows]="8" [tableStyle]="{ 'min-width': '50rem' }">
                        <ng-template pTemplate="header">
                            <tr>
                                <th class="text-center">
                                    {{'goal' | translate}}
                                </th>
                                <th class="text-center">
                                    {{'indicator' | translate}}
                                </th>

                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-item let-i="rowIndex">
                            @if(!item.is_deleted)
                            {
                            <tr>
                                <td>
                                    {{item.goal_name}}
                                </td>
                                <td>
                                    {{item.indicator_name}}
                                </td>

                            </tr>
                            }




                        </ng-template>
                    </p-table>
                </div>
                }



                @if(tabletype=='risks'){

                <div>
                    <div class="mt-5">
                        <p-table appendTo="body" [class]="dir" [dir]="dir" [value]="project.risks" [paginator]="true"
                            [rows]="8" [tableStyle]="{ 'min-width': '50rem' }">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>
                                        {{'risk'|translate}}

                                    </th>
                                    <th>
                                        {{'description'|translate}}

                                    </th>
                                    <th>
                                        {{'likelihood'|translate}}
                                    </th>
                                    <th>
                                        {{'impact'|translate}}
                                    </th>
                                    <th>
                                        {{'risk_weight'|translate}}

                                    </th>
                                    <th>
                                        {{'preventive_action'|translate}}
                                    </th>
                                    <th>
                                        {{'reponsible_risk'|translate}}
                                    </th>
                                    <th>
                                        {{'risk_type'|translate}}
                                    </th>


                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-risk>
                                <tr>
                                    <td>
                                        {{risk.name}}
                                    </td>
                                    <td>
                                        {{risk.description}}
                                    </td>
                                    <td>
                                        {{risk.likelihood_name}}
                                    </td>
                                    <td>
                                        {{risk.impact_name}}
                                    </td>
                                    <td>
                                        <p-tag [style]="{'background-color':getWeightColor(risk.weight)}"
                                            value="{{risk.weight}}/25" />
                                    </td>
                                    <td>
                                        {{risk.action}}
                                    </td>
                                    <td>
                                        {{risk.in_charge_name}}
                                    </td>
                                    <td>
                                        {{risk.type_name}}
                                    </td>


                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
                }
                @if(tabletype=='teamWork'){

                <div class="mt-5">
                    <p-table appendTo="body" [class]="dir" [dir]="dir" [value]="project.teamMembers" [paginator]="true"
                        [rows]="8" [tableStyle]="{ 'min-width': '50rem' }">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>
                                    {{'name' | translate}}
                                </th>
                                <th class="c-green">
                                    {{'job_title' | translate}}
                                </th>
                                <th class="c-blue">
                                    {{'section_department' | translate}}
                                </th>
                                <th class="c-orange">
                                    {{'linkage' | translate}}
                                </th>
                                <th>
                                    {{'task_summary' | translate}}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-item let-i="rowIndex">
                            <tr>
                                <td>
                                    {{item.name}}
                                </td>
                                <td class="c-green">
                                    {{item.job_title}}
                                </td>
                                <td class="c-blue">
                                    {{item.department_name}}
                                </td>
                                <td class="c-orange">
                                    @if(item.is_primary_connection){
                                    {{'primary' | translate}}
                                    }
                                    @else {
                                    {{'secondary' | translate}}
                                    }
                                </td>
                                <td>
                                    {{item.activity}}
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                }
                @if(tabletype=='milestone'){

                <div class="mt-5">
                    <p-table appendTo="body" [class]="dir" [dir]="dir" [value]="project.milestones" [paginator]="true"
                        [rows]="8" [tableStyle]="{ 'min-width': '50rem' }">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>
                                    {{'milestone' | translate}}
                                </th>
                                <th>
                                    {{'description' | translate}}
                                </th>

                                <th>
                                    {{'outputs' | translate}}
                                </th>
                                <th>
                                    {{'implementation_period' | translate}}
                                </th>
                                <th>
                                    {{'milestone_kpi' | translate}}
                                </th>
                                <th>
                                    {{'stage_status' | translate}}
                                </th>
                                <!-- <th>
                                    {{'positive_or_negative' | translate}}
                                </th> -->

                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-milestone>
                            <tr>
                                <td>
                                    {{milestone.name}}
                                </td>
                                <td>
                                    {{milestone.description}}
                                </td>
                                <td>
                                    {{milestone.outputs}}
                                </td>
                                <td>
                                    <div class="mb-2" style="min-width: 10rem;">
                                        <span class="font-semibold">من:</span> {{milestone.start_date|date}}

                                    </div>
                                    <div style="min-width: 10rem;">
                                        <span class="font-semibold">الي:</span> {{milestone.end_date|date}}

                                    </div>

                                </td>
                                <td>
                                    {{milestone.indicator_name}}
                                </td>
                                <td>
                                    @if(milestone.is_done){
                                    <p-tag severity="success" value="نفذت" />
                                    }
                                    @else if(milestone.is_done == null){
                                    <p-tag severity="scondary" value="لم تحدد بعد" />
                                    }
                                    @else{
                                    <p-tag severity="warning" value="قيد التنفيذ" />
                                    }
                                </td>


                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                }

            </div>

        </div>
    </div>
    <div class="g-overlay"></div>
</div>
}